export interface DeliveryTimeline {
  title: string;
  state: string;
  stateId: number;
  isExpress: boolean;
  sortOrder: number;
}

export enum DeliveryScope {
  Global = "global",
  Local = "local",
  Mixed = "mixed"
}

export interface ExpressDeliveryTimelinesProps {
  deliveryTimelines: DeliveryTimeline[];
  scope?: DeliveryScope;
  selectedSizeSource?: DeliveryScope.Global | DeliveryScope.Local | null;
}
